(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sth-complete-look"] && !Shopify.designMode) return;
  try {
    
function initSTHOutfits(root=document){root.querySelectorAll('[data-outfit-section]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';section.querySelectorAll('[data-add-outfit]').forEach(button=>{button.hidden=false;button.addEventListener('click',async()=>{const card=button.closest('.sth-outfit'),status=card.querySelector('[data-outfit-status]'),items=[...card.querySelectorAll('[data-piece]')].filter(p=>p.querySelector('[data-include]')?.checked).map(p=>({id:p.querySelector('[data-variant]').value,quantity:1}));if(!items.length){status.textContent=section.dataset.empty;return}button.disabled=true;status.textContent=section.dataset.loading;try{const response=await fetch(section.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||section.dataset.error);status.textContent=section.dataset.success;card.querySelector('[data-view-cart]').hidden=false;document.dispatchEvent(new CustomEvent('cart:refresh'));}catch(error){status.textContent=error.message||section.dataset.error}finally{button.disabled=false}})})})}initSTHOutfits();document.addEventListener('shopify:section:load',event=>initSTHOutfits(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sth-white-hero"] && !Shopify.designMode) return;
  try {
    
function initSTHWhiteHome(root){if(root.dataset.ready)return;root.dataset.ready='true';const note=root.querySelector('[data-sth-white-afterpay]');if(!note)return;note.hidden=false;const timer=window.setTimeout(()=>{note.hidden=true;},10000);note.querySelector('button').addEventListener('click',()=>{clearTimeout(timer);note.hidden=true;});}
document.querySelectorAll('[data-sth-white-home]').forEach(initSTHWhiteHome);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sth-white-home]').forEach(initSTHWhiteHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sth-white-style"] && !Shopify.designMode) return;
  try {
    
function initSTHWhiteStyle(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-sth-style-select]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-sth-style-lesson]').forEach(panel=>panel.hidden=panel.dataset.sthStyleLesson!==button.dataset.sthStyleSelect);root.querySelectorAll('[data-sth-style-select]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));root.querySelectorAll('[data-sth-style-lesson]').forEach(panel=>{const rail=panel.querySelector('.sth-white-style__rail');const go=direction=>{const max=rail.scrollWidth-rail.clientWidth;let next;if(direction>0)next=rail.scrollLeft>=max-5?0:Math.min(max,rail.scrollLeft+rail.clientWidth);else next=rail.scrollLeft<=5?max:Math.max(0,rail.scrollLeft-rail.clientWidth);rail.scrollTo({left:next,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};panel.querySelector('[data-sth-style-prev]').addEventListener('click',()=>go(-1));panel.querySelector('[data-sth-style-next]').addEventListener('click',()=>go(1));});}
document.querySelectorAll('[data-sth-style-studio]').forEach(initSTHWhiteStyle);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sth-style-studio]').forEach(initSTHWhiteStyle));

  } catch(e) { console.error(e); }
})();
})();
